import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Message } from 'src/app/Model/Message.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { MyMessagesService } from '../../../Services/MyMessages/my-messages.service';

@Component({
  selector: 'app-my-messages',
  templateUrl: './my-messages.component.html',
  styleUrls: ['./my-messages.component.css']
})
export class MyMessagesComponent implements OnInit {

  public Request: RequestModel;
  public nuevo = null;
  public MessageSelect;
  public type: string;
  public MessageSelectId : number = 0;
  requestMessages: Message[];
  documentMessages: Message[];
  constructor(
    private readonly Service: MyMessagesService,
    private readonly activeModal: NgbActiveModal,
    private readonly lsService : SessionStorageService) { }

  async ngOnInit() {
    this.loadByRequestCode();
    this.loadGetMessageDocument();
  }

  messageselect(id:number){
    this.MessageSelect = this.requestMessages.find(x => x.Id == id )
    this.MessageSelectId = this.MessageSelect.Id
  }

  async loadByRequestCode() {
    this.Service.getMyMessages(this.lsService.getLSItem("RequestCode")).then(res => {
      this.requestMessages = res;
    });
  }

  async loadGetMessageDocument() {
    this.Service.getMessageDocument(this.lsService.getLSItem("RequestCode")).then(res => {
      this.documentMessages = res;
    });
  }

  closeModal(){
    this.activeModal.dismiss();
  }
}
